import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "49",
  height: "48",
  fill: "none",
  viewBox: "0 0 49 48"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#312F2A",
      d: "M18.5 22.833h2.334v2.333H18.5zm0 4.667h2.334v2.333H18.5zm4.667-4.667H25.5v2.333h-2.333zm0 4.667H25.5v2.333h-2.333zm4.667-4.667h2.333v2.333h-2.333zm0 4.667h2.333v2.333h-2.333z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#312F2A",
      d: "M14.655 38h19.358c1.525 0 2.765-1.256 2.765-2.8V15.6c0-1.544-1.24-2.8-2.765-2.8h-2.766V10h-2.765v2.8h-8.296V10H17.42v2.8h-2.765c-1.525 0-2.766 1.256-2.766 2.8v19.6c0 1.544 1.24 2.8 2.766 2.8m19.358-19.6.001 16.8h-19.36V18.4z"
    }, null, -1)
  ]))]))
}
export default { render: render }